import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Header from './components/Header';
import Reference from './components/Reference';
import NotesCard from './components/NotesCard';
import GroupAddButtons from './components/GroupAddButtons';
import GroupControlButtons from './components/GroupControlButtons';
import axios from 'Axios';
import Snackbar from './components/SnackBar';
import moment from 'moment';
import { getCurrentProject } from 'Actions/ticketActions';
import { connect } from 'react-redux';
import CriteriaWrapper from './components/CriteriaWrapper';
import CriteriaWrapperColLeft from './components/CriteriaWrapperColLeft';
import CriteriaWrapperColRight from './components/CriteriaWrapperColRight';
import CriteriaWrapperGrid from './components/CriteriaWrapperGrid';
import CriteriaWrapperRow from './components/CriteriaWrapperRow';
import GenericComponent from './components/GenericComponent';
import CriteriaWrapperRowButtons from 'src/components/demand/Demand/screens/CETicket/components/CriteriaWrapperRowButtons';
import cetValidation from './validationSchema';
import { Formik } from 'formik';
import API from '../../../api';
import ConfirmDialog from './components/GroupControlButtons/components/ConfirmationDialog';
import Loader from 'Components/Loader';
import CriteriaGroup from './components/CriteriaGroup';
import { NoSimOutlined } from '@material-ui/icons';

function CETicket(props) {
  const { location, history, currentProject, match, setSugestion } = props;
  const [isReuse, setIsReuse] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [criteriaMapByUser, setCriteriaMapByUser] = useState([]);
  const [ticketData, setTicketData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [criteriaMapLeft, setCriteriaMapLeft] = useState([]);
  const [criteriaMapRight, setCriteriaMapRight] = useState([]);
  const [error, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [disabledAddImage, setDisabledAddImage] = useState(false);
  const [showErrorMsg, setShowErrorMessage] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [addNewCriteria, setAddNewCriteria] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedProperties, setSelectedProperties] = useState(null);
  const [mountingType, setMountType] = useState(null);
  const [mountingPosition, setMountPosition] = useState(null);
  const [selectedFromDropdown, setSelectedFromDropdown] = useState([]);
  const [selectRanges, setSelectRanges] = useState([]);
  const [selectDirect, setSelectDirect] = useState([]);
  const [selectOther, setSelectOther] = useState([]);
  const [keptImgIds, setKeptImgIds] = useState([]);
  const [newImgFiles, setNewImgFiles] = useState([]);
  const [endDate, setEndDate] = useState(null);
  const [ticketReference, setTicketReference] = useState(null);
  const [locationOnPlan, setLocationOnPlan] = useState(null);
  const [description, setDescription] = useState(null);
  const [note, setNote] = useState(null);
  const [disableIsue, setIsDisableIsue] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [criteriaErros, setCriteriaErros] = useState([]);
  const [indic, setIndic] = useState('');
  const [unitState, setUnitState] = useState('');
  const [prefixState, setPrefixState] = useState('');
  const [
    initialStateValuesForCreateTicket,
    setInitialStateValuesForCreateTicket,
  ] = useState({
    notes: 'Enter notes here',
    customeSettingsProtection: 'Enter custom settings here',
    startDate: new Date(),
    endDate: '',
    ticketReference: '',
    locationOnPlan: '',
    description: '',
    projectId: '',
    files: [],
    uploaded: false,
    imagePreviewUrl: {},
    keptImgIds: [],
    newImgFiles: [],
  });

  const [requiredQ, setRequiredQ] = useState({
    1: 9999,
    16: 9999,
    45: 9999,
    53: 9999,
    87: 9999,
    103: 9999,
  });
  const [questions, setQuestions] = useState([]);
  const [hasCircularEconomy, setHasCircularEconomy] = useState(false);

  const handleUnitChange = (value, isUnit) => {
    isUnit ? setUnitState(value) : setPrefixState(value);
  };

  const otherHasChanged = (value, parent, element) => {
    let elementFound = selectOther.find(option => option.criteriaId === parent);
    if (elementFound && selectOther.indexOf(elementFound) > -1) {
      selectOther.splice(selectOther.indexOf(elementFound), 1);
    }
    setSelectOther(selectOther =>
      selectOther.concat({ criteriaId: parent, value, master: element.id })
    );
  };

  const setSelectedDropdown = item => {
    if (
      item.name.toLowerCase() !== 'other' &&
      item.name.toLowerCase() !== 'ral (enter value)' &&
      item.name.toLowerCase() !== 'coloured' &&
      item.name.toLowerCase() !== 'enter manufacturer and model' &&
      item.name.toLowerCase() !== 'colour (enter colour)' &&
      item.name.toLowerCase() !== 'powder-coated (enter colour)' &&
      item.name.toLowerCase() !== 'nema enclosure' &&
      item.name.toLowerCase() !== 'nema' &&
      item.name.toLowerCase() !== 'minimum r9 value' &&
      item.name.toLowerCase() !== 'enter minimum cri value' &&
      item.name.toLowerCase() !== 'enter dimming range (%)' &&
      item.name.toLowerCase() !== 'ies tm-30 - priority level' &&
      item.name.toLowerCase() !== 'ies tm-30 - indices' &&
      item.name.toLowerCase() !== 'beam angle (enter value or range)' &&
      item.name.toLowerCase() !== 'tunable / dynamic white' &&
      item.name.toLowerCase() !== 'remote (enter distance to luminaire)'
    ) {
      let elementFound = selectedFromDropdown.find(
        option => option.parent === item.parent
      );
      if (elementFound && selectedFromDropdown.indexOf(elementFound) > -1) {
        selectedFromDropdown.splice(
          selectedFromDropdown.indexOf(elementFound),
          1
        );
      }
      selectDirect.find(direct => {
        return direct.criteriaId === item.id;
      }) &&
        selectDirect.splice(
          selectDirect.indexOf(
            selectDirect.find(direct => {
              return direct.criteriaId === item.id;
            })
          ),
          1
        );
      setSelectedFromDropdown(selectedFromDropdown =>
        selectedFromDropdown.concat(item)
      );
    }
    if (selectedFromDropdown.find(option => option.parent === item.parent))
      selectedFromDropdown.splice(
        selectedFromDropdown.indexOf(
          selectedFromDropdown.find(drop => {
            return drop.parent === item.parent;
          })
        ),
        1
      );
    if (selectOther.find(other => other.master === item.parent))
      selectOther.splice(
        selectOther.indexOf(
          selectOther.find(other => {
            return other.master === item.parent;
          })
        ),
        1
      );
    if (item.name.toLowerCase() !== 'ies tm-30 - priority level') {
      let help_arr = selectDirect.filter(direct => {
        return direct.master !== item.parent;
      });
      setSelectDirect(help_arr);
    } else {
      if (selectDirect.find(other => other.master === item.parent))
        selectDirect.splice(
          selectDirect.indexOf(
            selectDirect.find(other => {
              return other.master === item.parent;
            })
          ),
          1
        );
    }
    if (item.name.toLowerCase() !== 'ies tm-30 - indices') {
      let help_arr_range = selectRanges.filter(range => {
        return range.master !== item.parent;
      });
      setSelectRanges(help_arr_range);
    } else {
      if (selectRanges.find(other => other.master === item.parent))
        selectRanges.splice(
          selectRanges.indexOf(
            selectRanges.find(other => {
              return other.master === item.parent;
            })
          ),
          1
        );
    }
  };

  function extractSecondValue(input) {
    // Check if the input contains two consecutive hyphens (`--`)
    if (input.includes('--')) {
      // Regex to capture the last number after `--`, keeping the optional `-`
      const regex = /--(-?\d+)$/;
      const match = input.match(regex);
      return match ? `-${match[1]}` : null; // Add `-` in front of the matched number
    }

    // If no `--`, extract the last number without modification
    const regex = /-?(\d+)$/;
    const match = input.match(regex);
    return match ? match[1] : null;
  }

  function isSecondValueNegative(input) {
    // Regex to check if the second number is negative
    const regex = /--?\d+$/; // Match the last number, which may include a leading '-' (with one or two hyphens)

    const match = input.match(regex);

    // Check if the match is valid and if the last number has a negative sign
    return match ? match[0].startsWith('-') : false;
  }

  // function containsDoubleHyphen(input) {
  //   return /--/.test(input);
  // }

  const setEnteredRange = (
    event,
    child,
    grandchild,
    withMask,
    indicator,
    isUnit,
    isPrefix
  ) => {
    if (!isUnit && !isPrefix) {
      //if with mask enabled means range value is x - y
      let unit = '';
      let prefix = '';
      if (child.children) {
        if (
          child.children.find(g => {
            return g.id === grandchild.id;
          }) &&
          child.children.find(g => {
            return g.id === grandchild.id;
          }).units
        ) {
          unitState !== ''
            ? (unit = unitState)
            : (unit = child.children.find(g => {
                return g.id === grandchild.id;
              }).units[0]);
        }
        if (
          child.children.find(g => {
            return g.id === grandchild.id;
          }) &&
          child.children.find(g => {
            return g.id === grandchild.id;
          }).prefixes
        ) {
          prefixState !== ''
            ? (prefix = prefixState)
            : (prefix = child.children.find(g => {
                return g.id === grandchild.id;
              }).prefixes[0]);
        }
        if (
          child.children.find(g => {
            return g.id === grandchild.id;
          }) &&
          child.children.find(g => {
            return g.id === grandchild.id;
          }).unitLabel &&
          child.children.find(g => {
            return g.id === grandchild.id;
          }).unitLabel !== '' &&
          child.children.find(g => {
            return g.id === grandchild.id;
          }).unitLabel !== '/'
        ) {
          unit = child.children.find(g => {
            return g.id === grandchild.id;
          }).unitLabel;
        }
      }
      if (withMask) {
        //check if range has already been added to the list (master will be for example: Luminaire Dimensions)
        let rangeItem = selectRanges.find(range => {
          return range.criteriaId === grandchild.id;
        });
        if (rangeItem) {
          let value = '';
          if (indicator) {
            if (child.name === 'Ambient Temperature' && rangeItem.value) {
              // debugger;
              // const containsTwoHypens = containsDoubleHyphen(rangeItem.value);
              const secondValue = extractSecondValue(rangeItem.value);
              if (event === '') {
                value = secondValue;
              } else if (event === '-') {
                value = secondValue;
              } else {
                value = event + '-' + secondValue;
              }
            } else {
              if (rangeItem.value && rangeItem.value.split('-')[1] !== '') {
                let temp = rangeItem.value.split('-')[1];
                value = event + '-' + temp;
              } else {
                value = event + '-';
              }
            }
            if (value !== '-') {
              selectRanges.splice(selectRanges.indexOf(rangeItem), 1);
              let rangeObject = {
                master: child.id,
                criteriaId: grandchild.id,
                value: value,
                unit:
                  rangeItem && rangeItem.unit !== ''
                    ? rangeItem.unit
                    : grandchild.unitLabel &&
                      grandchild.unitLabel !== '' &&
                      grandchild.unitLabel !== '/'
                    ? grandchild.unitLabel
                    : unit,
                prefix:
                  rangeItem && rangeItem.prefix !== ''
                    ? rangeItem.prefix
                    : prefix
                    ? prefix
                    : '',
                checkValue: true,
              };
              setSelectRanges(selectRanges => selectRanges.concat(rangeObject));
            }
          } else {
            if (child.label === 'Ambient Temperature' && rangeItem.value) {
              if (rangeItem.value.startsWith('-')) {
                const extractFirstValue = '-' + rangeItem.value.split('-')[1];
                value = extractFirstValue + '-' + event;
              } else {
                const extractFirstValue = rangeItem.value.split('-')[0];
                value = extractFirstValue + '-' + event;
              }
            } else if (
              rangeItem.value &&
              rangeItem.value.split('-')[0] !== ''
            ) {
              let temp = rangeItem.value.split('-')[0];
              value = temp + '-' + event;
            } else {
              value = '-' + event;
            }

            if (value !== '-') {
              selectRanges.splice(selectRanges.indexOf(rangeItem), 1);
              let rangeObject = {
                master: child.id,
                criteriaId: grandchild.id,
                value: value,
                unit:
                  rangeItem && rangeItem.unit !== ''
                    ? rangeItem.unit
                    : grandchild.unitLabel &&
                      grandchild.unitLabel !== '' &&
                      grandchild.unitLabel !== '/'
                    ? grandchild.unitLabel
                    : unit,
                prefix:
                  rangeItem && rangeItem.prefix !== ''
                    ? rangeItem.prefix
                    : prefix
                    ? prefix
                    : '',
                checkValue: true,
              };
              setSelectRanges(selectRanges => selectRanges.concat(rangeObject));
            }
          }
        } else {
          if (event && event !== '') {
            let value = '';
            if (indicator) {
              if (event === '-' && child.label === 'Ambient Temperature') {
                value = event;
              } else {
                value = event + '-';
              }
            } else {
              value = '-' + event;
            }
            if (child.label === 'Ambient Temperature' && value === '-') {
              let rangeObject = {
                master: child.id,
                criteriaId: grandchild.id,
                value: value,
                unit: '',
                prefix: '',
                checkValue: true,
              };
              setSelectRanges(selectRanges => [...selectRanges, rangeObject]);
              return;
            }
            if (value !== '-') {
              let rangeObject = {
                master: child.id,
                criteriaId: grandchild.id,
                value: value,
                unit: '',
                prefix: '',
                checkValue: true,
              };
              setSelectRanges(selectRanges => [...selectRanges, rangeObject]);
            }
          }
        }
      } else {
        let rangeItem = selectRanges.find(range => {
          return range.criteriaId === grandchild.id;
        });
        if (rangeItem) {
          selectRanges.splice(selectRanges.indexOf(rangeItem), 1);
        }
        let rangeObject = {
          master: child.id,
          criteriaId: grandchild.id,
          value: event,
          unit:
            rangeItem && rangeItem.unit !== ''
              ? rangeItem.unit
              : grandchild.unitLabel &&
                grandchild.unitLabel !== '' &&
                grandchild.unitLabel !== '/'
              ? grandchild.unitLabel
              : unit,
          prefix:
            rangeItem && rangeItem.prefix !== ''
              ? rangeItem.prefix
              : prefix
              ? prefix
              : '',
          checkValue: true,
        };
        setSelectRanges(selectRanges => [...selectRanges, rangeObject]);
      }
    } else {
      let rangeItem = selectRanges.find(range => {
        return range.criteriaId === grandchild.id;
      });
      if (rangeItem) {
        let temp = rangeItem;
        temp.unit = isUnit ? event : temp.unit;
        temp.prefix = isPrefix ? event : temp.prefix;
        selectRanges.splice(selectRanges.indexOf(rangeItem), 1);
        setSelectRanges(selectRanges => selectRanges.concat(temp));
      } else {
        let rangeObject = {
          master: child.id,
          criteriaId: grandchild.id,
          value: '',
          unit: isUnit
            ? event
            : grandchild.unitLabel &&
              grandchild.unitLabel !== '' &&
              grandchild.unitLabel !== '/'
            ? grandchild.unitLabel
            : '',
          prefix: isPrefix ? event : '',
          checkValue: true,
        };
        setSelectRanges(selectRanges => selectRanges.concat(rangeObject));
      }
    }
  };

  const addResponseRequestData = data => {
    for (let i = 0; i < data.length; i++) {
      switch (data[i].type) {
        case 'SELECT':
          setSelectedFromDropdown(selectedFromDropdown =>
            selectedFromDropdown.concat({
              id: data[i].child,
              parent: data[i].parent,
              name: data[i].name,
            })
          );
          break;
        case 'VALUE':
          setSelectDirect(selectDirect =>
            selectDirect.concat({
              master: data[i].parent,
              criteriaId: data[i].child,
              value: data[i].value,
            })
          );
          break;
        case 'RANGE_VALUE_UNIT':
          let rangeObject = {
            master: data[i].parent,
            criteriaId: data[i].child,
            value: data[i].value,
            unit: data[i].unit ? data[i].unit : '',
            prefix: data[i].prefix ? data[i].prefix : '',
            checkValue: true,
          };
          setSelectRanges(selectRanges => selectRanges.concat(rangeObject));
          break;
        case 'RANGE':
          let range = {
            master: data[i].parent,
            criteriaId: data[i].child,
            value: data[i].value,
            unit: data[i].unit ? data[i].unit : '',
            prefix: data[i].prefix ? data[i].prefix : '',
            checkValue: true,
          };
          setSelectRanges(selectRanges => selectRanges.concat(range));
          break;
        case 'VALUE_RANGE_UNIT':
          let valueRangeObject = {
            master: data[i].parent,
            criteriaId: data[i].child,
            value: data[i].value,
            unit: data[i].unit ? data[i].unit : '',
            prefix: data[i].prefix ? data[i].prefix : '',
            checkValue: true,
          };
          setSelectRanges(selectRanges =>
            selectRanges.concat(valueRangeObject)
          );
          break;
        case 'TEXTAREA':
          setSelectOther(selectOther =>
            selectOther.concat({
              criteriaId: data[i].child,
              value: data[i].value,
              master: data[i].parent,
            })
          );
      }
    }
  };

  const getMyCriteria = () => {
    axios
      .get('criteria/form')
      .then(response => {
        if (response.data) {
          setCriteriaMapByUser(response.data);
          setCriteriaMapLeft(response.data.slice(0, 4));
          setCriteriaMapRight(response.data.slice(4, response.data.length));
        }
      })
      .catch(error => {
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        setErrorMessage(errorMessage);
      });
  };

  const getTicketById = data => {
    axios
      .get('/project/' + data.projectId + '/ticket/' + data.ticketId)
      .then(response => {
        if (response.status === 200) {
          const initialValueForTicket = initialStateValuesForCreateTicket
            ? initialStateValuesForCreateTicket
            : null;

          if (!isReuse) {
            initialValueForTicket.endDate = new Date(response.data.validUntil);
            setEndDate(new Date(response.data.validUntil));
          }
          if (!isReuse) {
            initialValueForTicket.startDate = new Date(
              response.data.creatorInfo.dateCreated
            );
          }
          //assets from backend with id-s
          if (response.data.assets !== null) {
            initialValueForTicket.keptImgIds = response.data.assets;
          }
          setTicketData(response.data);
          setTicketReference(response.data.referenceName);
          setLocationOnPlan(response.data.locationOnPlan);
          setDescription(response.data.description);
          setNote(response.data.note);
          setKeptImgIds(response.data.assets ? response.data.assets : []);
          setInitialStateValuesForCreateTicket(initialValueForTicket);
          addResponseRequestData(response.data.criteriaValues);
          setHasCircularEconomy(response.data.hasCircularEconomy);
          const circularEconomy = response.data.circularEconomyGroups;

          for (let i = 0; i < circularEconomy.length; i++) {
            questions.push(circularEconomy[i]);
          }

          for (let i = 0; i < questions.length; i++) {
            setRequiredQ(prevState => ({
              ...prevState,
              [questions[i]]: questions[i],
            }));
          }
        }
      })
      .catch(err => {
        if (err.response) {
          setErrorMessage(err.response.data.message);
          setShowError(true);
        }
      });
  };

  useEffect(() => {
    setLoading(true);
    for (let i = 0; i < questions.length; i++) {
      setRequiredQ(prevState => ({
        ...prevState,
        [questions[i]]: questions[i],
      }));
    }
    let length = window.location.pathname.split('/').length;
    let indicator = window.location.pathname.split('/')[length - 1];
    setIndic(indicator);
    props.getCurrentProject(match.params.projectId);
    localStorage.setItem('projectId', match.params.projectId);
    localStorage.setItem('ticketId', match.params.ticketId);
    //If ticketId exist then Edit
    if (location.state && location.state.hasOwnProperty('isReuse')) {
      const projectId = match.params.projectId && match.params.projectId;
      const ticketId = location.state.ticketId && location.state.ticketId;
      getTicketById({ projectId, ticketId });
      setCurrentProjectId(match.params.projectId);
      setIsReuse(true);
      getMyCriteria();
    } else if (match.params.hasOwnProperty('ticketId')) {
      const projectId = match.params.projectId && match.params.projectId;
      const ticketId = match.params.ticketId && match.params.ticketId;
      getTicketById({ projectId, ticketId });
      setIsEdit(true);
      getMyCriteria();
    } else {
      setCurrentProjectId(match.params.projectId);
      setIsCreate(true);
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + 7);
      const initStateValuesForCreateTicket = initialStateValuesForCreateTicket;
      initStateValuesForCreateTicket.endDate = endDate;
      setEndDate(endDate);
      setInitialStateValuesForCreateTicket(initStateValuesForCreateTicket);
    }
    // cleanup
    return prevProps => {
      if (location.state && location.state.hasOwnProperty('isReuse')) {
        if (
          location.state.ticketId !==
          (prevProps.location.state && prevProps.location.state.ticketId)
        ) {
          const projectId = location.state.projectId;
          const ticketId = location.state.ticketId;
          getTicketById({ projectId, ticketId });
          resetState();
          setState({ isReuse: true });
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          getMyCriteria();
        }
      }
    };
  }, []);

  const resetState = () => {
    setIsReuse(false);
  };

  const handleChangeDate = name => date => {
    const today = new Date();
    const todayTime = moment(today).format('HH.mm');
    const hoursAndMinutes = todayTime.split('.');
    const validUntil = moment(date)
      .add(hoursAndMinutes[0], 'hour')
      .add(hoursAndMinutes[1], 'minute')
      .toDate();
    const initialValueForCreate = initialStateValuesForCreateTicket;
    initialValueForCreate[name] = validUntil;
    setEndDate(validUntil);
    setInitialStateValuesForCreateTicket(initialValueForCreate);
  };

  const deleteFromRange = id => {
    let tempRanges = selectRanges.filter(range => range.criteriaId === id);

    if (tempRanges) {
      selectRanges.find(range => range.criteriaId === id).value = '';
    }

    if (ticketData) {
      let tempData = ticketData.criteriaValues.find(
        value => value.child === id
      );

      if (tempData) {
        ticketData.criteriaValues.find(value => value.child === id).value = '';
      }
    }
    // selectRanges.splice(
    //   selectRanges.indexOf(
    //     selectRanges.find(range => {
    //       return range.master === id;
    //     })
    //   ),
    //   1
    // );
  };

  const handleChangeNotes = value => {
    setNote(value);
  };

  const handleChange = name => event => {
    console.log(name);
    // const initStateValuesForCriteria = initialStateValuesForCriteria;
    // initStateValuesForCriteria[name] = event.target.value;
    // setInitialStateValuesForCreateTicket(initStateValuesForCriteria)
  };

  const addNewCriteriaToDefault = newCriteria => {
    return;
    // let criteriaMapByUser = JSON.parse(
    //   JSON.stringify(this.state.criteriaMapByUser)
    // );
    // let parentId = newCriteria.parentId;
    // if (parentId === 15 || parentId === 16) {
    //   criteriaMapByUser.mounting.forEach(mounting => {
    //     if (mounting.id === parentId) {
    //       mounting.values.push(newCriteria);
    //     }
    //   });
    // } else if (parentId === 332) {
    //   let propName = newCriteria.name.replace(/\s/g, '');
    //   criteriaMapByUser[`${propName}`] = {};
    //   criteriaMapByUser[`${propName}`]['id'] = newCriteria.id;
    //   criteriaMapByUser[`${propName}`]['name'] = newCriteria.name;
    //   criteriaMapByUser[`${propName}`]['values'] = [
    //     {
    //       name: 'Not set',
    //       id: 9999,
    //     },
    //   ];
    //   criteriaMapByUser[`${propName}`]['other'] = true;
    // } else {
    //   Object.keys(criteriaMapByUser).forEach(key => {
    //     if (criteriaMapByUser[key].id === parentId) {
    //       criteriaMapByUser[key].values.push(newCriteria);
    //     }
    //   });
    // }
    // this.setState({ criteriaMapByUser: criteriaMapByUser });
  };

  const removeCriteriaFromDefault = newCriteria => {
    return;
    // let criteriaMapByUser = JSON.parse(
    //   JSON.stringify(this.state.criteriaMapByUser)
    // );
    // let parentId = newCriteria.parentId;

    // if (parentId === 15 || parentId === 16) {
    //   criteriaMapByUser.mounting.forEach(mounting => {
    //     if (mounting.id === parentId) {
    //       Object.keys(criteriaMapByUser.mounting).forEach(key => {
    //         if (criteriaMapByUser.mounting[key].id === parentId) {
    //           criteriaMapByUser.mounting[
    //             key
    //           ].values = criteriaMapByUser.mounting[key].values.filter(
    //             item => item.id !== newCriteria.id
    //           );
    //         }
    //       });
    //     }
    //   });
    // } else {
    //   Object.keys(criteriaMapByUser).forEach(key => {
    //     if (parentId === 332 && criteriaMapByUser[key].id === newCriteria.id) {
    //       delete criteriaMapByUser[key];
    //     } else if (criteriaMapByUser[key].id === parentId) {
    //       criteriaMapByUser[key].values = criteriaMapByUser[key].values.filter(
    //         item => item.id !== newCriteria.id
    //       );
    //     }
    //   });
    // }
    // this.setState({ criteriaMapByUser: criteriaMapByUser });
  };

  const handleCloseAddNewCriteriaDialog = (
    msg,
    newCriteria,
    deleteCriteria = false
  ) => {
    if (msg) {
      setAddNewCriteria(false);
      setErrorMessage(msg);
      setShowErrorMessage(true);
      if (newCriteria && deleteCriteria !== true) {
        addNewCriteriaToDefault(newCriteria);
      }
      if (newCriteria && deleteCriteria === true) {
        removeCriteriaFromDefault(newCriteria);
      }
    } else {
      setAddNewCriteria(false);
    }
  };

  const deleteImage = (identifier, type) => event => {
    let initialStateValuesForCreateTicket = initialStateValuesForCreateTicket;
    let keptImagesIDS = [...keptImgIds];
    let newImagesFILES = [...newImgFiles];
    if (type === 'existing') {
      delete keptImagesIDS[identifier];

      //reindex files array
      keptImagesIDS = keptImagesIDS.filter(file => {
        return file;
      });
    } else {
      delete newImagesFILES[identifier];

      //reindex files array
      newImagesFILES = newImagesFILES.filter(file => {
        return file;
      });
    }
    setKeptImgIds(keptImagesIDS);
    setNewImgFiles(newImagesFILES);
    setDisabledAddImage(false);
  };

  const onFileUpload = event => {
    event.preventDefault();
    const keptImagesIds = keptImgIds.length;
    const newImgesFiles = newImgFiles.length;

    // ovaj deo trebamo da izmenimo da budu moguce samo 3 slike
    if (keptImagesIds + newImgesFiles === 2) {
      event.target.value = '';
      setErrorMessage('You can only upload up to 2 images');
      setShowErrorMessage(true);
      setDisabledAddImage(true);
      return true;
    }

    const file = event.target.files[0];

    if (file.size > 5242880) {
      event.target.value = '';
      setErrorMessage('Image size cannot be greater then 5 MB');
      setShowErrorMessage(true);
      return true;
    }

    let reader = new FileReader();
    let newImagesFiles = [...newImgFiles];
    reader.onloadend = () => {
      file.url = reader.result;
      newImagesFiles.push(file);
      setNewImgFiles(newImagesFiles);
    };
    reader.readAsDataURL(file);
    event.target.value = '';
  };

  const handleOpenAddNewCriteriaDialog = (
    selectedGroup = null,
    property = null
  ) => {
    setAddNewCriteria(true);
    setSelectedGroup(selectedGroup);
    setSelectedProperties(property);
  };

  const resetStateForErorr = () => {
    setErrorMessage('');
    setShowErrorMessage(false);
  };

  const setMountingType = (name, param) => {
    if (name.toLowerCase() === 'mounting type') {
      setMountType(param);
    } else if (name.toLowerCase() === 'mounting position') {
      setMountPosition(param);
    }
  };

  const clearDrop = id => {
    let elementFound = selectedFromDropdown.find(
      option => option.parent === id
    );
    if (elementFound && selectedFromDropdown.indexOf(elementFound) > -1) {
      let help = [...selectedFromDropdown];
      help.splice(help.indexOf(elementFound), 1);
      setSelectedFromDropdown(help);
    }
  };

  const rangeSwitchToValue = master => {
    // let helper_array = selectRanges.filter(range => range.master === master);
    let tempRanges = selectRanges.filter(range => range.criteriaId === master);

    if (tempRanges) {
      for (let i = 0; i < selectRanges.length; i++) {
        if (selectRanges[i].master === master) selectRanges[i].value = '';
      }
    }

    // let tempData =
    //   ticketData.criteriaValues &&
    //   ticketData.criteriaValues.find(value => value.child === master);

    if (ticketData) {
      if (ticketData.criteriaValues) {
        for (let i = 0; i < ticketData.criteriaValues.length; i++) {
          if (ticketData.criteriaValues[i].parent === master) {
            ticketData.criteriaValues[i].value = '';
          }
        }
      }
    }

    // ticketData.criteriaValues.find(value => value.child === id).value = '';

    // setSelectRanges(selectRanges);
  };

  const handleQuestions = (event, id) => {
    setRequiredQ(prevState => ({ ...prevState, [id]: event.target.value }));
    if (
      event.target.value !== 9999 &&
      !questions.includes(event.target.value)
    ) {
      questions.push(event.target.value);
    } else {
      setQuestions(questions.filter(question => question !== id));
    }
  };

  // const postQuestions = () => {
  //   let formData = new FormData();
  //   for (let id = 0; id < questions.length; id++) {
  //     formData.append(`circularEconomyGroups[${id}]`, questions[id]);
  //   }
  //   return formData;
  // };

  const createCritera = async (data, indicator, edit) => {
    let path = '';
    if (!edit) {
      path = indicator
        ? `/project/${match.params.projectId}/ticket`
        : `/project/${match.params.projectId}/ticket/add-draft`;
      axios
        .post(path, data, {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.status === 200) {
            history.push('/demand/project/' + match.params.projectId);
          }
        })
        .catch(err => {
          if (err) {
            // setShowErrorMessage(true);
            if (err.response) {
              if (
                err.response.data.message &&
                err.response.data.message ===
                  'Error: unable to submit - see the error list'
              ) {
                setErrorMsg(err.response.data.message);
                setCriteriaErros(err.response.data.criteriaErrors);
              }
              setErrorMsg(
                err.response.data.message &&
                  err.response.data.message !==
                    'Something went wrong please try again' &&
                  err.response.data.messageData
                  ? err.response.data.messageData
                  : err.response.data.message
              );
            }
            setErrorMessage(err.response.data.message);
            setShowErrorMessage(true);
            setShowError(true);
            setIsDisableIsue(false);
          }
        });
    } else {
      path = `/project/${match.params.projectId}/ticket/${ticketData.ticketId}?confirm=${confirmOpen}`;
      axios
        .post(path, data, {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.status === 200) {
            setConfirmOpen(false);
            history.push('/demand/project/' + match.params.projectId);
          } else {
            setConfirmOpen(true);
          }
        })
        .catch(err => {
          if (err) {
            if (err.response) {
              if (
                err.response.data.message &&
                err.response.data.message ===
                  'Error: unable to submit - see the error list'
              ) {
                setErrorMsg(err.response.data.message);
                setCriteriaErros(err.response.data.criteriaErrors);
              }
              setErrorMsg(
                err.response.data.message &&
                  err.response.data.message !==
                    'Something went wrong please try again' &&
                  err.response.data.messageData
                  ? err.response.data.messageData
                  : err.response.data.message
              );
            }
            setShowError(true);
            if (err.response.data.status === 2102) setConfirmOpen(true);
            setShowErrorMessage(true);
            setIsDisableIsue(false);
          }
        });
    }
  };

  const getAllCriteria = () => {
    return [
      ...selectedFromDropdown,
      ...selectDirect,
      ...selectOther,
      ...selectRanges,
    ];
  };

  const createPostFormData = () => {
    const newImagesFiles = newImgFiles;
    const expiration = endDate.valueOf();
    const gatheredData = getAllCriteria();

    let formData = new FormData();
    const ticketImageName = mountingPosition + '_' + mountingType;
    if (ticketImageName) formData.append('ticketImageName', ticketImageName);
    if (note) formData.append('note', encodeURI(note));
    if (expiration) formData.append('expiration', expiration);
    if (ticketReference) formData.append('referenceName', ticketReference);
    if (locationOnPlan) formData.append('locationOnPlan', locationOnPlan);
    if (description) formData.append('description', description);
    if (locationOnPlan) formData.append('name', locationOnPlan);
    if (isEdit) formData.append('assets', keptImgIds);
    if (isReuse) formData.append('assets', keptImgIds);
    if (questions) {
      for (let id = 0; id < questions.length; id++) {
        formData.append(`circularEconomyGroups[${id}]`, questions[id]);
      }
    }
    if (newImagesFiles) {
      for (let i = 0; i < newImagesFiles.length; i++) {
        formData.append('newAssets', newImagesFiles[i]);
      }
    }
    if (gatheredData) {
      const filteredData = gatheredData.filter(item => {
        if (item.value)
          if (item.value.includes('-')) {
            if (item.criteriaId === 2358) {
              return item;
            } else {
              const splittedValue = item.value.split('-');
              if (splittedValue[0] !== '' && splittedValue[1] !== '') {
                return item;
              }
            }
          }
        return item;
      });
      for (let p = 0; p < filteredData.length; p++) {
        if (filteredData[p].id) {
          if (filteredData[p].value) {
          }
          formData.append(
            `criteriaValues[${p}].criteriaId`,
            filteredData[p].id
          );
        }
        if (filteredData[p].criteriaId) {
          if (filteredData[p].checkValue) {
            if (filteredData[p].value) {
              formData.append(
                `criteriaValues[${p}].criteriaId`,
                filteredData[p].criteriaId
              );
            }
          } else {
            formData.append(
              `criteriaValues[${p}].criteriaId`,
              filteredData[p].criteriaId
            );
          }
        }
        if (
          filteredData[p].value &&
          filteredData[p].unit &&
          filteredData[p].unit !== ''
        ) {
          formData.append(
            `criteriaValues[${p}].unit`,
            filteredData[p].unit.trim()
          );
        }
        if (filteredData[p].prefix && filteredData[p].prefix !== '') {
          formData.append(
            `criteriaValues[${p}].prefix`,
            filteredData[p].prefix.trim()
          );
        }
        if (filteredData[p].value) {
          formData.append(
            `criteriaValues[${p}].value`,
            filteredData[p].value.toString().trim()
          );
        }
      }
    }
    return formData;
  };

  const onSave = (data, event) => {
    if (ticketReference === '') {
      setErrorMsg('Mandatory fields cannot be empty!');
      setShowErrorMessage(true);
    } else {
      let formData = createPostFormData();
      if (isEdit) {
        if (ticketData.ticketState === 'DRAFT') {
          if (data.action === 'draft') {
            // editCriteria
            createCritera(formData, true, isEdit);
          } else {
            formData.append('shouldPublish', true);
            //edit criteria
            createCritera(formData, true, isEdit);
          }
        } else {
          if (data.action === 'draft') {
            //doedit
            createCritera(formData, true, isEdit);
          }
        }
      } else {
        if (data.action === 'create') {
          setIsDisableIsue(true);
          createCritera(formData, true, isEdit);
        } else {
          createCritera(formData, false, isEdit);
        }
      }
      // for ([key, value] of formData.entries()) {
      //   console.log(key, value);
      // }
    }
  };

  // const confirmEdit = () => {
  //   setConfirmOpen(true);
  // };

  const handleCloseCD = () => {
    setConfirmOpen(false);
  };

  const doEdit = () => {
    let formData = createPostFormData();
    createCritera(formData, true, isEdit);
  };

  const clearOther = id => {
    let elementFound = selectOther.find(option => option.criteriaId === id);
    if (elementFound && selectOther.indexOf(elementFound) > -1) {
      let help = [...selectOther];
      help.splice(help.indexOf(elementFound), 1);
      setSelectOther(help);
    }
  };

  const clearDirect = id => {
    let elementFound = selectDirect.find(option => option.criteriaId === id);
    if (elementFound && selectDirect.indexOf(elementFound) > -1) {
      let help = [...selectDirect];
      help.splice(help.indexOf(elementFound), 1);
      setSelectDirect(help);
    }
  };

  const changeInDirect = (value, child, grandchild) => {
    if (grandchild) {
      let elementFound = selectDirect.find(
        option => option.criteriaId === grandchild.id
      );
      if (elementFound) {
        selectDirect.splice(selectDirect.indexOf(elementFound), 1);
      }
      if (value !== '' && value !== null && value !== undefined) {
        setSelectDirect(selectDirect =>
          selectDirect.concat({
            master: child.id,
            criteriaId: grandchild.id,
            value,
          })
        );
      }
    } else {
      let elementFound = selectDirect.find(
        option => option.master === child.id
      );
      if (elementFound) {
        selectDirect.splice(selectDirect.indexOf(elementFound), 1);
      }
      if (value !== '' && value !== null && value !== undefined) {
        setSelectDirect(selectDirect =>
          selectDirect.concat({ master: child.id, criteriaId: child.id, value })
        );
      }
    }
  };

  const createDataOnlyCriteria = () => {
    const gatheredData = getAllCriteria();
    let formData = new FormData();
    if (gatheredData) {
      for (let p = 0; p < gatheredData.length; p++) {
        if (gatheredData[p].id) {
          formData.append(
            `criteriaValues[${p}].criteriaId`,
            gatheredData[p].id
          );
        }
        if (gatheredData[p].criteriaId) {
          formData.append(
            `criteriaValues[${p}].criteriaId`,
            gatheredData[p].criteriaId
          );
        }
        if (gatheredData[p].unit && gatheredData[p].unit !== '') {
          formData.append(
            `criteriaValues[${p}].unit`,
            gatheredData[p].unit.trim()
          );
        }
        if (gatheredData[p].prefix && gatheredData[p].prefix !== '') {
          formData.append(
            `criteriaValues[${p}].prefix`,
            gatheredData[p].prefix.trim()
          );
        }
        if (gatheredData[p].value) {
          formData.append(
            `criteriaValues[${p}].value`,
            gatheredData[p].value.toString().trim()
          );
        }
      }
    }
    return formData;
  };

  const onSuggest = () => event => {
    let formData = createDataOnlyCriteria();
    for ([key, value] of formData.entries()) {
      console.log(key, value);
    }
    if (getAllCriteria().length < 2) {
      window.scrollTo(0, 0);
      setErrorMsg('At least two criteria needed for suggestions');
      setShowErrorMessage(true);
      return;
    }
    API.getSuggestedTickets(formData)
      .then(res => {
        if (res.status === 200) {
          setSugestion(formData);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  const setRefData = (value, indicator) => {
    if (indicator === 'ticketReference') {
      setTicketReference(value);
    } else if (indicator === 'locationOnPlan') {
      setLocationOnPlan(value);
    } else if (indicator === 'description') {
      setDescription(value);
    }
  };

  const setLoader = what => {
    setLoading(false);
  };

  return (
    <Formik validationSchema={cetValidation}>
      {props => (
        <Grid item className="flex-dashboard">
          <Header
            history={history}
            ticketData={ticketData}
            isEdit={isEdit}
            isReuse={isReuse}
            projectName={currentProject && currentProject.name}
          />
          <Reference
            mountingType={mountingType}
            mountingPosition={mountingPosition}
            startDate={initialStateValuesForCreateTicket.startDate}
            endDate={endDate}
            onChangeDate={handleChangeDate}
            isEdit={isEdit}
            ticketReference={isEdit ? ticketReference : ''}
            locationOnPlan={isEdit ? locationOnPlan : ''}
            description={isEdit ? description : ''}
            setTicketReference={setRefData}
            setLocationOnPlan={setRefData}
            setDescription={setRefData}
            onSuggest={onSuggest}
          />
          <CriteriaWrapper>
            <CriteriaWrapperGrid container spacing={40}>
              <CriteriaWrapperRow>
                <CriteriaWrapperColLeft>
                  {isEdit ? (
                    criteriaMapLeft.length > 0 ? (
                      <React.Fragment>
                        <GenericComponent
                          {...props}
                          realCriteriaMap={criteriaMapByUser}
                          criteriaMap={criteriaMapLeft}
                          isEdit={isReuse ? isReuse : isEdit}
                          loading={isEdit ? loading : false}
                          setMountingType={setMountingType}
                          setSelectedFromDropdown={setSelectedDropdown}
                          setEnteredRange={setEnteredRange}
                          rangeSwitchToValue={rangeSwitchToValue}
                          changeInDirect={changeInDirect}
                          otherHasChanged={otherHasChanged}
                          clearOther={clearOther}
                          clearDirect={clearDirect}
                          clearDrop={clearDrop}
                          deleteFromRange={deleteFromRange}
                          ticketData={ticketData}
                          setLoader={setLoader}
                          getCriteriaMap={getMyCriteria}
                          side={true}
                          criteriaErros={criteriaErros}
                          handleUnitChange={handleUnitChange}
                          unitState={unitState}
                          hasCircularEconomy={hasCircularEconomy}
                        />
                        {criteriaErros && criteriaErros.length !== 0 && (
                          <div
                            style={{
                              margin: '1.5em 0',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '18px',
                                color: '#f44336',
                                fontWeight: '600',
                              }}
                            >
                              Search Form Errors
                            </span>
                            {criteriaErros.map(error => {
                              return (
                                <div
                                  style={{
                                    marginTop: '1.5em',
                                    color: '#f44336',
                                  }}
                                >
                                  {error.criteria}: {error.errorMessage}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </React.Fragment>
                    ) : (
                      <Loader isLoading={loading} />
                    )
                  ) : (
                    <React.Fragment>
                      <GenericComponent
                        {...props}
                        realCriteriaMap={criteriaMapByUser}
                        criteriaMap={criteriaMapLeft}
                        isEdit={isReuse ? isReuse : isEdit}
                        loading={isEdit ? loading : false}
                        setMountingType={setMountingType}
                        setSelectedFromDropdown={setSelectedDropdown}
                        setEnteredRange={setEnteredRange}
                        rangeSwitchToValue={rangeSwitchToValue}
                        changeInDirect={changeInDirect}
                        otherHasChanged={otherHasChanged}
                        clearOther={clearOther}
                        clearDirect={clearDirect}
                        clearDrop={clearDrop}
                        deleteFromRange={deleteFromRange}
                        ticketData={ticketData}
                        setLoader={setLoader}
                        getCriteriaMap={getMyCriteria}
                        side={true}
                        criteriaErros={criteriaErros}
                        handleUnitChange={handleUnitChange}
                        unitState={unitState}
                        hasCircularEconomy={hasCircularEconomy}
                      />
                      {criteriaErros && criteriaErros.length !== 0 && (
                        <div
                          style={{
                            margin: '1.5em 0',
                          }}
                        >
                          <span
                            style={{
                              fontSize: '18px',
                              color: '#f44336',
                              fontWeight: '600',
                            }}
                          >
                            Search Form Errors
                          </span>
                          {criteriaErros.map(error => {
                            return (
                              <div
                                style={{
                                  marginTop: '1.5em',
                                  color: '#f44336',
                                }}
                              >
                                {error.criteria}: {error.errorMessage}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </React.Fragment>
                  )}
                  {indic === 'create' ? (
                    <GroupAddButtons
                      showImages={true} // TODO make new component without "showImages"!
                      isEdit={isReuse ? false : isEdit}
                      initialStateValuesForCreateTicket={
                        initialStateValuesForCreateTicket
                      }
                      keptImgIds={keptImgIds}
                      newImgFiles={newImgFiles}
                      trigerHandleChange={handleChange}
                      trigerDeleteImage={deleteImage}
                      onFileUpload={onFileUpload}
                      //dodaj u promenljive i sredi css za on hover
                      disableButton={disabledAddImage}
                      handleOpenAddNewCriteriaDialog={
                        handleOpenAddNewCriteriaDialog
                      }
                      resetStateForErorr={resetStateForErorr}
                    />
                  ) : (
                    !loading && (
                      <GroupAddButtons
                        showImages={true} // TODO make new component without "showImages"!
                        isEdit={isReuse ? false : isEdit}
                        initialStateValuesForCreateTicket={
                          initialStateValuesForCreateTicket
                        }
                        keptImgIds={keptImgIds}
                        newImgFiles={newImgFiles}
                        trigerHandleChange={handleChange}
                        trigerDeleteImage={deleteImage}
                        onFileUpload={onFileUpload}
                        //dodaj u promenljive i sredi css za on hover
                        disableButton={disabledAddImage}
                        handleOpenAddNewCriteriaDialog={
                          handleOpenAddNewCriteriaDialog
                        }
                        resetStateForErorr={resetStateForErorr}
                      />
                    )
                  )}
                </CriteriaWrapperColLeft>
                <CriteriaWrapperColRight>
                  {isEdit ? (
                    criteriaMapRight.length > 0 ? (
                      <React.Fragment>
                        <GenericComponent
                          {...props}
                          realCriteriaMap={criteriaMapByUser}
                          criteriaMap={criteriaMapRight}
                          isEdit={isReuse ? isReuse : isEdit}
                          loading={isEdit ? loading : false}
                          setMountingType={setMountingType}
                          setSelectedFromDropdown={setSelectedDropdown}
                          setEnteredRange={setEnteredRange}
                          rangeSwitchToValue={rangeSwitchToValue}
                          changeInDirect={changeInDirect}
                          clearOther={clearOther}
                          clearDirect={clearDirect}
                          clearDrop={clearDrop}
                          deleteFromRange={deleteFromRange}
                          otherHasChanged={otherHasChanged}
                          ticketData={ticketData}
                          setLoader={setLoader}
                          getCriteriaMap={getMyCriteria}
                          side={false}
                          criteriaErros={criteriaErros}
                          handleUnitChange={handleUnitChange}
                          unitState={unitState}
                          hasCircularEconomy={hasCircularEconomy}
                        />
                      </React.Fragment>
                    ) : (
                      <Loader isLoading={loading} />
                    )
                  ) : (
                    <React.Fragment>
                      <GenericComponent
                        {...props}
                        realCriteriaMap={criteriaMapByUser}
                        criteriaMap={criteriaMapRight}
                        isEdit={isReuse ? isReuse : isEdit}
                        loading={isEdit ? loading : false}
                        setMountingType={setMountingType}
                        setSelectedFromDropdown={setSelectedDropdown}
                        setEnteredRange={setEnteredRange}
                        rangeSwitchToValue={rangeSwitchToValue}
                        changeInDirect={changeInDirect}
                        clearOther={clearOther}
                        clearDirect={clearDirect}
                        clearDrop={clearDrop}
                        deleteFromRange={deleteFromRange}
                        otherHasChanged={otherHasChanged}
                        ticketData={ticketData}
                        setLoader={setLoader}
                        getCriteriaMap={getMyCriteria}
                        side={false}
                        criteriaErros={criteriaErros}
                        handleUnitChange={handleUnitChange}
                        unitState={unitState}
                        hasCircularEconomy={hasCircularEconomy}
                      />
                    </React.Fragment>
                  )}

                  {indic === 'create' ? (
                    <div>
                      <CriteriaGroup
                        isCrtiteriaTitle={true}
                        handleQuestions={handleQuestions}
                        requiredQ={requiredQ}
                        questions={questions}
                        name="Circular Economy Assessment"
                      ></CriteriaGroup>

                      <NotesCard
                        stateValues={note}
                        trigerHandleChange={handleChangeNotes}
                        id={'notes'}
                        isEdit={isEdit}
                        isReuse={isReuse}
                      />
                    </div>
                  ) : (
                    !loading && (
                      <div>
                        <CriteriaGroup
                          isCrtiteriaTitle={true}
                          handleQuestions={handleQuestions}
                          requiredQ={requiredQ}
                          questions={questions}
                          name="Circular Economy Assessment"
                        ></CriteriaGroup>
                        <NotesCard
                          stateValues={note}
                          trigerHandleChange={handleChangeNotes}
                          id={'notes'}
                          isEdit={isEdit}
                          isReuse={isReuse}
                        />
                      </div>
                    )
                  )}
                </CriteriaWrapperColRight>
              </CriteriaWrapperRow>
            </CriteriaWrapperGrid>
            {indic === 'create' ? (
              <CriteriaWrapperRowButtons>
                <CriteriaWrapperColLeft>
                  <GroupAddButtons
                    showImages={false} // TODO make new component without "showImages"!
                    isEdit={isReuse ? false : isEdit}
                    initialStateValuesForCreateTicket={
                      initialStateValuesForCreateTicket
                    }
                    trigerHandleChange={handleChange}
                    trigerDeleteImage={deleteImage}
                    onFileUpload={onFileUpload}
                    //dodaj u promenljive i sredi css za on hover
                    disableButton={disabledAddImage}
                    addNewCriteria={addNewCriteria}
                    handleCloseAddNewCriteriaDialog={
                      handleCloseAddNewCriteriaDialog
                    }
                    handleOpenAddNewCriteriaDialog={
                      handleOpenAddNewCriteriaDialog
                    }
                    resetStateForErorr={resetStateForErorr}
                  />
                </CriteriaWrapperColLeft>
                <CriteriaWrapperColRight>
                  <GroupControlButtons
                    isEdit={isReuse ? false : isEdit}
                    isReuse={isReuse}
                    images={initialStateValuesForCreateTicket}
                    projectInfo={match.params}
                    expiration={endDate}
                    opticalDistribution={
                      // initialStateValuesForCriteria.opticalDistribution
                      () => console.log('ye')
                    }
                    history={history}
                    ticketState={ticketData !== null && ticketData.ticketState}
                    setSugestion={setSugestion}
                    onFormSave={onSave}
                  />
                </CriteriaWrapperColRight>
              </CriteriaWrapperRowButtons>
            ) : (
              !loading && (
                <CriteriaWrapperRowButtons>
                  <CriteriaWrapperColLeft>
                    <GroupAddButtons
                      showImages={false} // TODO make new component without "showImages"!
                      isEdit={isReuse ? false : isEdit}
                      initialStateValuesForCreateTicket={
                        initialStateValuesForCreateTicket
                      }
                      trigerHandleChange={handleChange}
                      trigerDeleteImage={deleteImage}
                      onFileUpload={onFileUpload}
                      //dodaj u promenljive i sredi css za on hover
                      disableButton={disabledAddImage}
                      addNewCriteria={addNewCriteria}
                      handleCloseAddNewCriteriaDialog={
                        handleCloseAddNewCriteriaDialog
                      }
                      handleOpenAddNewCriteriaDialog={
                        handleOpenAddNewCriteriaDialog
                      }
                      resetStateForErorr={resetStateForErorr}
                    />
                  </CriteriaWrapperColLeft>
                  <CriteriaWrapperColRight>
                    <GroupControlButtons
                      isEdit={isReuse ? false : isEdit}
                      isReuse={isReuse}
                      images={initialStateValuesForCreateTicket}
                      projectInfo={match.params}
                      expiration={endDate}
                      opticalDistribution={
                        // initialStateValuesForCriteria.opticalDistribution
                        () => console.log('ye')
                      }
                      history={history}
                      ticketState={
                        ticketData !== null && ticketData.ticketState
                      }
                      setSugestion={setSugestion}
                      onFormSave={onSave}
                    />
                  </CriteriaWrapperColRight>
                </CriteriaWrapperRowButtons>
              )
            )}
          </CriteriaWrapper>
          {showErrorMsg === true && errorMsg && (
            <Snackbar
              open={true}
              msg={errorMsg}
              resetState={resetStateForErorr}
            />
          )}
          <ConfirmDialog
            open={confirmOpen}
            handleClose={handleCloseCD}
            confirmAction={doEdit}
          ></ConfirmDialog>
        </Grid>
      )}
    </Formik>
  );
}

const mapStateToProps = store => {
  return {
    currentProject: store.currentProject.project,
  };
};
const mapDispatchToProps = dispatch => ({
  getCurrentProject: projectId => {
    dispatch(getCurrentProject(projectId));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(CETicket);
